import React from 'react';
import { Outlet, useParams } from 'react-router-dom';
import { useAtom } from 'jotai/index';
import {
  programmationIdAtom,
  programmationIsV2Atom,
} from 'containers/Programmations/atoms/progAtoms';

export function ProgWrapper() {
  const { programmationId, matiereId } = useParams<{
    programmationId: string;
    matiereId;
  }>();
  const [, setProgrammationId] = useAtom(programmationIdAtom);
  const [, setProgrammationV2] = useAtom(programmationIsV2Atom);
  setProgrammationId(programmationId);
  setProgrammationV2(true);
  return <Outlet key={matiereId} />;
}
